console.log("✅ custom-script.js est bien chargé et en cours d'exécution !");

// Vérification immédiate après chargement du DOM
document.addEventListener("DOMContentLoaded", function () {
    console.log("📢 DOM chargé, vérification de normalizeString...");

    // Définition globale de normalizeString
    window.normalizeString = function (str) {
        console.log("🔍 Execution de normalizeString avec :", str); // Vérification dans la console

        const accentMap = {
            "é": "e", "è": "e", "ê": "e", "ë": "e",
            "à": "a", "â": "a", "ä": "a",
            "ô": "o", "ö": "o",
            "î": "i", "ï": "i",
            "ù": "u", "ü": "u",
            "ç": "c", "ñ": "n"
        };

        return str.split("").map(char => accentMap[char] || char).join("")
            .replace(/[^a-z0-9\s-]/gi, "") // Supprime caractères spéciaux sauf espaces et "-"
            .replace(/\s+/g, "-") // Remplace espaces par "-"
            .replace(/-+/g, "-") // Supprime les "--" en trop
            .replace(/^-|-$/g, "") // Supprime les "-" en début et fin
            .toLowerCase();
    };

    console.log("✅ Fonction normalizeString() est maintenant bien déclarée !");
});
